export const device = state => state.DeviceReducer.device
export const types = state => state.DeviceReducer.types
export const info = state => state.DeviceReducer.info